// ------------------------------ library
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";

// ------------------------------ local function
import { pathMaker } from "../../../utils/helperFunctions";
import WebInfoContext from "../../../context/WebInfo/WebInfoContext.ts";
import SubCategory from "./SubCategory";

// ------------------------------ local file
import "./dropdown.css";

const MenuDropDown = () => {
  const webInfo = useContext(WebInfoContext);
  // console.log(webInfo.categorys[0]?.subs, "www");

  const [showSubCategory, setShowSubCategory] = useState(false);
  const [title, setTitle] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categoryId, setCategoryId] = useState("");
  // console.log(subCategory, "subCategory");
  useEffect(() => {
    setSubCategory(webInfo.categorys[0]?.subs);
  }, []);
  return (
    <div className="digi_drop_menu">
      <ul
        className="digi_category-menu pd-t-8"
        style={{ paddingBottom: "60px" }}
      >
        {webInfo.categorys.length > 0 &&
          webInfo.categorys.map((item) =>{
            if(item.hashtag.type == 0 || item.hashtag.type == 1){
            return(
            <Link
              key={item.hashtag.id}
              className="text-decoration-none"
              to={`/category/${item.hashtag.id}`}
            >
              <li
                className="digi_category-item pointer"
                onMouseOver={(e) => {
                  setShowSubCategory(true);
                  setTitle(item.hashtag.txt);
                  setSubCategory(item.subs);
                  setCategoryId(item.hashtag.id);
                }}
              >
                {/* <img
                  className="wh-20 digi_Category-icon"
                  src={pathMaker(item.hashtag.icon)}
                /> */}
                <span className="digi_category-link">{item.hashtag.txt}</span>
              </li>
            </Link>
          )}})}
      </ul>
      {showSubCategory == true ? (
        <SubCategory
          title={title}
          subCategory={subCategory}
          categoryId={categoryId}
        ></SubCategory>
      ) : (
        <SubCategory
          title={webInfo?.categorys[0]?.hashtag.txt}
          subCategory={webInfo?.categorys[0]?.subs}
          categoryId={webInfo?.categorys[0]?.hashtag.id}
        ></SubCategory>
      )}
    </div>
  );
};

export default MenuDropDown;
